import { useRouter } from 'next/router';

import * as routes from 'pages/routes';

import * as userResource from 'resources/user/hooks';

import * as userHelpers from 'resources/user/user.helpers';

const useListedKitRestrictions = () => {
  const router = useRouter();

  const { hasAdminPermissions } = userResource.useCurrentUserPermissions();

  const { data: user } = userResource.useCurrentUser();

  const isClient = userHelpers.isClient(user);
  const isCoordinatorOrAdmin = userHelpers.isCoordinatorOrAdmin(user);

  // detecting default listedKits by url
  const isDefaultListedKit = router.pathname === routes.path.listedKitDetails;

  const isListedKitItemsUpdatable = (
    (isDefaultListedKit && hasAdminPermissions) || (!isDefaultListedKit && !isClient)
  );

  return {
    isEditable: isListedKitItemsUpdatable,
    isAddAuditEnabled: isCoordinatorOrAdmin,
    isDeselectAuditCheckpointEnabled: isCoordinatorOrAdmin,
  };
};

export default useListedKitRestrictions;
